module.exports = __webpack_public_path__ + "img/Karlos-Presumido.43d996a3.jpg";